import { Injectable } from '@angular/core';

declare var require: any;
var Papa: any = require("papaparse");
@Injectable()
export class CsvService {
  dummyData = `id,first_name,last_name,email,gender,ip_address
              1,Gloria,Price,gprice0@gizmodo.com,Female,160.80.60.121
              2,Lois,Gray,lgray1@weibo.com,Female,144.71.4.145
              3,Joseph,Anderson,janderson2@mozilla.org,Male,136.19.137.123
              4,Peter,Lynch,plynch3@timesonline.co.uk,Male,23.215.162.82
              5,George,Jones,gjones4@shutterfly.com,Male,153.109.131.254
              6,Frank,Barnes,fbarnes5@g.co,Male,184.218.76.117
              7,Arthur,Kelley,akelley6@apache.org,Male,67.159.246.223
              8,Jonathan,George,jgeorge7@1688.com,Male,238.118.83.25
              9,Cheryl,Rivera,crivera8@ft.com,Female,219.177.160.109
              10,Antonio,Mitchell,amitchell9@uiuc.edu,Male,117.127.253.163`

  constructor() { }

  dummyUserImportParse(numRows: number) {
    let parsedData = Papa.parse(this.dummyData, { preview: numRows + 1 }).data;
    parsedData.shift();
    return parsedData;
  }

  // returns all columns, but only specified number of rows
  parseLimitedRows(file: any, numRows: number, callback: any) {
    Papa.parse(file, {
      preview: numRows,
      complete: (results, file) => {
        callback(results.data);
      },
      skipEmptyLines: true
    });
  }

  // returns all rows, but only a specified number of columns
  parseLimitedColumns(file: any, numCols: number, callback: any) {
    Papa.parse(file, {
      complete: (results, file) => {
        let csvJson = results.data;
        let finalResults = [];

        for (let i = 0; i < csvJson.length; i++) {
          let tempResults = [];
          for (let j = 0; j < numCols; j++) {
            tempResults.push(csvJson[i][j]);
          }
          finalResults.push(tempResults);
        }
        callback(finalResults);
      }
    })
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/csv/csv.service.ts